import React from 'react';
import './Blog.css';

const Blog = () => {
    return (
        <div className='bg-blue-500 m-10 p-10'>
            <h1 className='font-bold text-3xl mb-3 text-white'>Blog</h1>
            <div className='blog-item'>
                <h1 className='font-bold text-2xl mb-3'>What is the purpose of react router?</h1>
                <p><span className='font-bold text-2xl mb-2'>Answer:</span>
                    React Router plays an important role to display multiple views in a single page application. Without React Router,
                    it is not possible to display multiple views in React applications. Most of the social media websites like Facebook, Instagram uses React Router for rendering multiple views.
                </p>
            </div>
            <div className='blog-item'>
                <h1 className='font-bold text-2xl mb-3'>How does context api works?</h1>
                <p><span className='font-bold text-2xl mb-2'>Answer:</span>
                    The React.createContext is all you need.
                    Provider is a component that as it's names suggests provides the state to its children.
                    Consumer as it so happens is a component that consumes and uses the state.
                </p>
            </div>
            <div className='blog-item'>
                <h1 className='font-bold text-2xl mb-3'>how UseRef hook works?</h1>
                <p><span className='font-bold text-2xl mb-2'>Answer:</span>
                    The useRef Hook allows you to persist values between renders.
                    It can be used to store a mutable value that does not cause a re-render when updated.
                    It can be used to access a DOM element directly.
                    useRef() only returns one item. It returns an Object called current.
                </p>
            </div>
        </div>
    );
};

export default Blog;